import React from 'react';
import SocialEngineeringMap from "../map/socialEngineeringMap";

const SocialEngineeringModule = () => {
    return (
    <SocialEngineeringMap/>
)
}
export default SocialEngineeringModule;